import * as React from 'react'
import { File, FileSpreadsheet, FileText } from 'lucide-react'
import type { CommunityMessageAttachment } from '../services/communityService'
import {
  getAttachmentDisplayName,
  getFileExtension,
  isImageAttachment,
} from '../utils/communityAttachments'

export type CommunityMessageAttachmentsProps = {
  attachments: CommunityMessageAttachment[]
  onOpenLightbox: (attachments: CommunityMessageAttachment[], index: number) => void
}

function getFileIconByExtension(ext: string) {
  if (ext === 'pdf' || ext === 'txt' || ext === 'md' || ext === 'json') return FileText
  if (ext === 'xls' || ext === 'xlsx' || ext === 'csv') return FileSpreadsheet
  return File
}

export function CommunityMessageAttachments({
  attachments,
  onOpenLightbox,
}: CommunityMessageAttachmentsProps) {
  const list = Array.isArray(attachments) ? attachments.filter((a) => a && a.url) : []
  if (!list.length) return null

  const imageAttachments = list.filter((att) => isImageAttachment(att))
  let imageIndex = 0

  return (
    <div className="mt-2 flex flex-wrap gap-2">
      {list.map((att, index) => {
        const isImage = isImageAttachment(att)
        if (isImage) {
          const currentIndex = imageIndex
          imageIndex += 1
          return (
            <button
              key={att.id ?? `${att.url}-${index}`}
              type="button"
              onClick={(event) => {
                event.preventDefault()
                onOpenLightbox(imageAttachments, currentIndex)
              }}
              className="group relative h-16 w-16 overflow-hidden rounded-md border border-[#2a2a2a] bg-[#111111]"
            >
              <img
                src={att.url}
                alt="Imagem anexada à mensagem"
                className="h-full w-full object-cover transition-transform duration-150 group-hover:scale-105"
              />
            </button>
          )
        }

        const name = getAttachmentDisplayName({ url: att.url, storagePath: att.storagePath })
        const ext = getFileExtension(name)
        const Icon = getFileIconByExtension(ext)

        return (
          <a
            key={att.id ?? `${att.url}-${index}`}
            href={att.url}
            target="_blank"
            rel="noopener noreferrer"
            className="relative flex h-16 max-w-[320px] items-center gap-2 overflow-hidden rounded-md border border-[#2a2a2a] bg-[#111111] px-2 hover:bg-[#151515]"
            title={name}
          >
            <Icon className="h-5 w-5 flex-none text-foreground/70" />
            <div className="min-w-0">
              <div className="truncate text-[12px] text-foreground/90">{name}</div>
              <div className="text-[11px] text-foreground/50">{ext ? ext.toUpperCase() : 'ARQUIVO'}</div>
            </div>
          </a>
        )
      })}
    </div>
  )
}

